






















































































































































































import { Vue, Prop, Component, Watch } from 'vue-property-decorator';

@Component({
  name: 'ams-float-table'
})
export default class AMSFloatTable extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  items!: any[];
  @Prop({
    default: () => {
      return [];
    }
  })
  headers!: any[];

  innerHeader: any[] = [];

  centerWidth: number = 0;
  centerRealWidth: number = 0;
  centerCount: number = 0;

  getPercent(item: any) {
    let per = 0;
    let width = item.width;
    if (this.centerWidth > this.centerRealWidth) {
      per = width / this.centerWidth;
    } else {
      per = width / this.centerRealWidth;
    }
    // console.log('百分比:' + per);
    return `${per * 100}%`;
  }

  /**获取居中样式 */
  getAlignClass(item: any) {
    if (!item.align) return 'flex-center';
    switch (item.align) {
      case 'left':
        return 'flex-left';
      case 'right':
        return 'flex-right';
      case 'center':
        return 'flex-center';
      default:
        return 'flex-center';
    }
  }

  @Watch('centerRealWidth', { immediate: true, deep: true })
  onCenterRealWidthChange(value: any, oldValue: any) {
    this.resize();
  }

  resize() {
    // console.log(this.centerRealWidth + '-' + this.centerWidth);
    if (this.centerRealWidth > this.centerWidth) {
      // console.log('重新计算宽度');
      const width = this.centerRealWidth / this.centerCount;
      this.innerHeader.map((v: any) => {
        if (!v.fixed) {
          v.width = width + 1.5;
        }
      });
    } else {
      // console.log('不用计算宽度');
      this.innerHeader = [];
      this.headers.map((v: any) => {
        const item = Object.assign({}, v);
        this.innerHeader.push(item);
      });
    }
  }

  @Watch('centerWidth', { immediate: true, deep: true })
  onCenterWidthChange(value: any, oldValue: any) {
    if (value > 0) {
      this.$nextTick(() => {
        this.updateContentWidth();
      });
    }
  }

  updateContentWidth() {
    const left = (this.$refs.left as any).getBoundingClientRect().right;
    const right = (this.$refs.right as any).getBoundingClientRect().left;
    const distance = right - left;
    this.centerRealWidth = distance;
    // console.log(this.centerRealWidth + '-' + this.centerWidth);
  }

  mounted() {
    window.onresize = () => {
      return (() => {
        this.updateContentWidth();
      })();
    };

    // (this.$refs['amsTable'] as Element).addEventListener('scroll', () => {
    //   const table = this.$refs['amsTable'] as Element;
    //   const left = (this.$refs['amsTable'] as Element).scrollLeft;
    //   const offset = (this.centerRealWidth > this.centerWidth ? this.centerRealWidth : this.centerWidth) / 2.0 - 10;
    //   if (left >= offset) {
    //     table.scrollTo(offset, 0);
    //   }
    //   console.log((this.$refs['amsTable'] as Element).scrollLeft);
    // });
  }

  @Watch('headers', { immediate: true, deep: true })
  onHeadersChange(value: any, oldValue: any) {
    // console.log(this.innerHeader);
    this.innerHeader = [];
    value.map((v: any) => {
      const item = Object.assign({}, v);
      this.innerHeader.push(item);
    });

    let width = 0;
    let count = 0;
    value.map((v: any) => {
      if (!v.fixed) {
        width += isNaN(parseInt(v.width)) ? 0 : parseInt(v.width);
        count += 1;
      }
    });
    this.centerWidth = width;
    this.centerCount = count;
    this.$nextTick(() => {
      this.resize();
    });
  }

  get lastBodyIndex() {
    const left = this.innerHeader.filter(v => {
      return v.fixed == 'left';
    });
    const body = this.innerHeader.filter(v => {
      return !v.fixed || v.fixed == '';
    });
    const index = left.length + body.length - 1;
    return index;
  }

  get totalWidth() {
    var total = 0;
    this.innerHeader.map((v: any) => {
      const width = parseInt(v.width);
      total += width;
    });
    return `width:${total}px`;
  }

  get leftWidthStyle() {
    var total = 0;
    this.innerHeader.map((v: any) => {
      if (v.fixed == 'left') {
        const width = parseInt(v.width);
        total += width;
      }
    });
    return `width:${total}px`;
  }

  get leftWidth() {
    var total = 0;
    this.innerHeader.map((v: any) => {
      if (v.fixed == 'left') {
        const width = parseInt(v.width);
        total += width;
      }
    });
    return total;
  }

  get rightWidthStyle() {
    var total = 0;
    this.innerHeader.map((v: any) => {
      if (v.fixed == 'right') {
        const width = parseInt(v.width);
        total += width;
      }
    });
    return `width:${total}px`;
  }

  get rightWidth() {
    var total = 0;
    this.innerHeader.map((v: any) => {
      if (v.fixed == 'right') {
        const width = parseInt(v.width);
        total += width;
      }
    });
    return total;
  }

  get sortRightHead() {
    const rights = this.innerHeader.filter(v => {
      return v.fixed == 'right';
    });
    const other = this.innerHeader.filter(v => {
      return v.fixed != 'right';
    });
    return [...rights, ...other];
  }

  onSort(item: any, index: number, order: string) {
    console.log(item);
    var head = item;
    if (order == item.sortType) {
      head.sortType = undefined;
    } else {
      head.sortType = order;
    }

    this.innerHeader.splice(index, 1, head);
    item.sortter(item);
  }

  currentIndex: number = -1;
  onMouseEnter(item: any, index: any) {
    if (index != this.currentIndex) {
      this.currentIndex = index;
    }
  }

  onMouseLeave() {
    this.currentIndex = -1;
  }
}
